import constate from 'constate'
import { EntityId, TemporalEntityId } from 'entities-next/common'
import { QueryFunctionContext, QueryStatus, useQuery } from 'react-query'

import {
  getApiScoutingCampaignHandlers,
  SCOUTING_CAMPAIGN_CACHE_STORE_ID,
  ScoutingCampaign,
} from '../../../../../../entities-next/scoutingCampaign'
import { newScoutingCampaign } from '../../../../../../entities-next/scoutingCampaign/scoutingCampaign.helpers'

export type ScoutingCampaignDetailsViewStore = {
  state: {
    scoutingCampaignId: number
    scoutingCampaign?: ScoutingCampaign
    actionBarRef: React.MutableRefObject<any>
    status: QueryStatus
  }
}

function useScoutingCampaignDetailsViewInternalStore({
  scoutingCampaignId,
  actionBarRef,
}: Pick<
  ScoutingCampaignDetailsViewStore['state'],
  'scoutingCampaignId' | 'actionBarRef'
>): ScoutingCampaignDetailsViewStore {
  const scoutingCampaignData = useScoutingCampaignEntity(scoutingCampaignId)
  return {
    state: { actionBarRef, ...scoutingCampaignData, scoutingCampaignId },
  }
}

function useScoutingCampaignEntity(scoutingCampaignId: EntityId) {
  const { data: scoutingCampaign, status } = useQuery(
    [SCOUTING_CAMPAIGN_CACHE_STORE_ID, scoutingCampaignId],
    scoutingCampaignQuery,
    {
      refetchOnWindowFocus: false,
    }
  )
  return {
    scoutingCampaignId,
    scoutingCampaign,
    status,
  }
}

async function scoutingCampaignQuery({
  queryKey,
}: QueryFunctionContext<[string, EntityId]>): Promise<ScoutingCampaign> {
  const [, scoutingCampaignId] = queryKey
  const isNew = scoutingCampaignId === TemporalEntityId.new
  const { apiGetScoutingCampaign } = getApiScoutingCampaignHandlers()
  return !isNew ? apiGetScoutingCampaign(scoutingCampaignId) : newScoutingCampaign()
}

export const [ScoutingCampaignDetailsViewProvider, useScoutingCampaignDetailsViewStore] = constate(
  useScoutingCampaignDetailsViewInternalStore
)
